// extracted by mini-css-extract-plugin
module.exports = {"item":"Pathway_item__5olPD","trigger":"Pathway_trigger__eHv9p","content":"Pathway_content__OG1EX"};